import React, { useState } from 'react';
import './Message.css';

const Message = () => {
  const [selectedChat, setSelectedChat] = useState(null);

  const conversations = [
    {
      id: 1,
      user: 'Sarah Johnson',
      avatar: '👩',
      lastMessage: 'Is the Golden Retriever still available?',
      time: '5 min ago',
      unread: 2,
      pet: 'Golden Retriever - Max'
    },
    {
      id: 2,
      user: 'Mike Chen',
      avatar: '👨',
      lastMessage: 'Thank you! I would love to meet the cat.',
      time: '1 hour ago',
      unread: 0,
      pet: 'Persian Cat - Luna'
    },
    {
      id: 3,
      user: 'Emma Davis',
      avatar: '👩',
      lastMessage: 'What time works best for you?',
      time: '3 hours ago',
      unread: 1,
      pet: 'Labrador - Bella'
    },
    {
      id: 4,
      user: 'John Smith',
      avatar: '👨',
      lastMessage: 'Perfect! See you tomorrow.',
      time: 'Yesterday',
      unread: 0,
      pet: 'German Shepherd - Rocky'
    }
  ];

  const messages = {
    1: [
      { sender: 'them', text: 'Hi! I saw your listing for Max.', time: '10:30 AM' },
      { sender: 'you', text: 'Hello! Yes, Max is still available.', time: '10:32 AM' },
      { sender: 'them', text: 'Is the Golden Retriever still available?', time: '10:35 AM' },
    ],
    2: [
      { sender: 'you', text: 'Luna is a very gentle cat, great with kids.', time: '9:15 AM' },
      { sender: 'them', text: 'Thank you! I would love to meet the cat.', time: '9:20 AM' },
    ]
  };

  return (
    <div className="message-page">
      <div className="page-header">
        <h1>💬 Messages</h1>
        <p>Chat with potential adopters</p>
      </div>

      <div className="message-container">
        <div className="conversations-list">
          <div className="conversations-header">
            <h3>Conversations</h3>
            <span className="unread-count">
              {conversations.reduce((sum, c) => sum + c.unread, 0)} unread
            </span>
          </div>

          {conversations.map(conv => (
            <div
              key={conv.id}
              className={`conversation-item ${selectedChat === conv.id ? 'active' : ''}`}
              onClick={() => setSelectedChat(conv.id)}
            >
              <div className="conv-avatar">{conv.avatar}</div>
              <div className="conv-content">
                <div className="conv-header">
                  <h4>{conv.user}</h4>
                  <span className="conv-time">{conv.time}</span>
                </div>
                <p className="conv-pet">{conv.pet}</p>
                <p className="conv-message">{conv.lastMessage}</p>
              </div>
              {conv.unread > 0 && (
                <span className="unread-badge">{conv.unread}</span>
              )}
            </div>
          ))}
        </div>

        <div className="chat-area">
          {selectedChat ? (
            <>
              <div className="chat-header">
                <div className="chat-user-info">
                  <span className="chat-avatar">
                    {conversations.find(c => c.id === selectedChat)?.avatar}
                  </span>
                  <div>
                    <h3>{conversations.find(c => c.id === selectedChat)?.user}</h3>
                    <p>{conversations.find(c => c.id === selectedChat)?.pet}</p>
                  </div>
                </div>
                <button className="more-btn">⋮</button>
              </div>

              <div className="chat-messages">
                {messages[selectedChat]?.map((msg, index) => (
                  <div key={index} className={`message ${msg.sender}`}>
                    <div className="message-bubble">
                      <p>{msg.text}</p>
                      <span className="message-time">{msg.time}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="chat-input-area">
                <input
                  type="text"
                  placeholder="Type a message..."
                  className="chat-input"
                />
                <button className="send-btn">📤</button>
              </div>
            </>
          ) : (
            <div className="no-chat-selected">
              <span className="no-chat-icon">💬</span>
              <h3>Select a conversation</h3>
              <p>Choose a conversation from the list to start messaging</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Message;
